import { TefComs4p } from '@mfe/components/TefComs4p';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeEdit = function render(this: TefComs4p, purpose : Purpose) : ReturnType<typeof html> {
  return html`
    <one-heading level="h6" variant="default">${purpose.title}</one-heading>
    <one-text as="p">
      ${purpose.shortDescription} ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
    </one-text>
    ${purpose.subscriptions.map((subscription) => this.getTemplateFn('singleSubscriptionEdit')(subscription))}
  `;
};
